// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5caeed58","498":"77b0ab6b","703":"3bca4fe1"}[chunkId] + ".chunk.js";
};